module.exports = __webpack_public_path__ + "img/pro_one_7.f23d0f41.jpg";